<template>
  <div
    :class="{'boxcontent-item':true, 'boxcontent-item-unavailable': material.quantity === 0 }"
    @click="select"
  >
    <img v-if="material.image" :src="material.image" />
    <img v-else src="/logokglnmcodnoia.png" />
    <p class="boxcontent-item-description">{{material.name}}</p>
    <p class="boxcontent-item-available" v-if="material.quantity > 0">dostępne {{material.quantity}}</p>
    <p class="boxcontent-item-available" v-else>Niedostępne</p>
  </div>
</template>

<script>
export default {
  props: {
    material: Object
  },
  methods: {
    select() {
      this.$emit("select", this.material);
    }
  }
};
</script>